import * as React from "react";
import { SimpleSingleSelect } from "../../../components/FormComponents/SimpleSingleSelect";
import { InputField, PhoneInputField } from "@coverme/forms";
import { TextArea } from "../../../components/FormComponents/TextArea";
import { Field } from "formik";
import { YesNoButtons } from "../../../components/FormComponents/YesNoButtons";

export const ThirdPartyLiabilityFields = ({
    thePatient,
    getErrors,
    isRequired,
    getValidationState,
    values,
    formikProps,
}) => {
    const { setFieldTouched, setFieldValue } = formikProps;
    return (
        <>
            <div className="form-section">
                <div className="form-control xxl-input">
                    <Field
                        name="thirdPartyLiability.typeOfAccident"
                        render={({ field }) => (
                            <SimpleSingleSelect
                                {...field}
                                title={`Type or location of accident`}
                                setFieldTouched={setFieldTouched}
                                setFieldValue={setFieldValue}
                                errorMessage={getErrors(field)}
                                required={isRequired(field)}
                                validState={getValidationState(field)}
                                options={[
                                    "At a place of business",
                                    "At someone's home",
                                    "Automobile",
                                    "Victim of violent crime",
                                    "Work-Related",
                                    "Other",
                                ]}
                            />
                        )}
                    />
                </div>
            </div>
            {values.thirdPartyLiability.typeOfAccident === "Automobile" && (
                <div className="form-section">
                    <div className="form-control m-280-input">
                        <Field
                            name="thirdPartyLiability.companyName"
                            render={({ field }) => (
                                <InputField
                                    id={field.name}
                                    title={"Auto Policy Company Name"}
                                    placeholder={"Auto Policy Company Name"}
                                    errorMessage={getErrors(field)}
                                    required={isRequired(field)}
                                    validState={getValidationState(field)}
                                    {...field}
                                />
                            )}
                        />
                    </div>
                    <div className="form-control m-input">
                        <Field
                            name="thirdPartyLiability.policyNumber"
                            render={({ field }) => (
                                <InputField
                                    id={field.name}
                                    title={"Auto Policy Number"}
                                    placeholder={"Auto Policy Number"}
                                    errorMessage={getErrors(field)}
                                    required={isRequired(field)}
                                    validState={getValidationState(field)}
                                    {...field}
                                />
                            )}
                        />
                    </div>
                    <div className="form-control m-input">
                        <Field
                            name="thirdPartyLiability.contactName"
                            render={({ field }) => (
                                <InputField
                                    id={field.name}
                                    title={"Contact Name"}
                                    placeholder={"Contact Name"}
                                    errorMessage={getErrors(field)}
                                    required={isRequired(field)}
                                    validState={getValidationState(field)}
                                    {...field}
                                />
                            )}
                        />
                    </div>

                    <div className="form-control s-160-input">
                        <Field
                            name="thirdPartyLiability.contactPhoneNumber"
                            render={({ field }) => (
                                <PhoneInputField
                                    {...field}
                                    title={"Phone Number"}
                                    id={field.name}
                                    value={field.value}
                                    errorMessage={getErrors(field)}
                                    required={isRequired(field)}
                                    validState={getValidationState(field)}
                                    changeEvent={e => {
                                        setFieldValue(field.name, e);
                                    }}
                                />
                            )}
                        />
                    </div>
                </div>
            )}
            {values.thirdPartyLiability.typeOfAccident === "Work-Related" && (
                <div className="form-section">
                    <div className="form-control l-input">
                        <Field
                            name="thirdPartyLiability.employerName"
                            render={({ field }) => (
                                <InputField
                                    id={field.name}
                                    title={"Employer Name"}
                                    placeholder={"Employer Name"}
                                    errorMessage={getErrors(field)}
                                    required={isRequired(field)}
                                    validState={getValidationState(field)}
                                    {...field}
                                />
                            )}
                        />
                    </div>
                    <div className="form-control l-input">
                        <Field
                            name="thirdPartyLiability.contactName"
                            render={({ field }) => (
                                <InputField
                                    id={field.name}
                                    title={"Employer Contact Name"}
                                    placeholder={"Employer Contact Name"}
                                    errorMessage={getErrors(field)}
                                    required={isRequired(field)}
                                    validState={getValidationState(field)}
                                    {...field}
                                />
                            )}
                        />
                    </div>
                    <div className="form-control l-input">
                        <Field
                            name="thirdPartyLiability.workCompCarrier"
                            render={({ field }) => (
                                <InputField
                                    id={field.name}
                                    title={"Worker's Comp Carrier"}
                                    placeholder={"Work Comp Carrier"}
                                    errorMessage={getErrors(field)}
                                    required={isRequired(field)}
                                    validState={getValidationState(field)}
                                    {...field}
                                />
                            )}
                        />
                    </div>
                    <div className="form-control l-input">
                        <Field
                            name="thirdPartyLiability.contactPhoneNumber"
                            render={({ field }) => (
                                <PhoneInputField
                                    {...field}
                                    title={"Worker's Comp Carrier Phone Number"}
                                    id={field.name}
                                    value={field.value}
                                    errorMessage={getErrors(field)}
                                    required={isRequired(field)}
                                    validState={getValidationState(field)}
                                    changeEvent={e => {
                                        setFieldValue(field.name, e);
                                    }}
                                />
                            )}
                        />
                    </div>
                </div>
            )}
            {values.thirdPartyLiability.typeOfAccident === "At someone's home" && (
                <div className="form-section">
                    <div className="form-control l-input">
                        <Field
                            name="thirdPartyLiability.homeownerCompany"
                            render={({ field }) => (
                                <InputField
                                    id={field.name}
                                    title={"Homeowner Company"}
                                    placeholder={"Homeowner Company"}
                                    errorMessage={getErrors(field)}
                                    required={isRequired(field)}
                                    validState={getValidationState(field)}
                                    {...field}
                                />
                            )}
                        />
                    </div>
                    <div className="form-control l-input">
                        <Field
                            name="thirdPartyLiability.contactName"
                            render={({ field }) => (
                                <InputField
                                    id={field.name}
                                    title={"Contact Name"}
                                    placeholder={"Contact Name"}
                                    errorMessage={getErrors(field)}
                                    required={isRequired(field)}
                                    validState={getValidationState(field)}
                                    {...field}
                                />
                            )}
                        />
                    </div>
                    <div className="form-control m-input">
                        <Field
                            name="thirdPartyLiability.policyNumber"
                            render={({ field }) => (
                                <InputField
                                    id={field.name}
                                    title={"Policy number"}
                                    placeholder={"Policy number"}
                                    errorMessage={getErrors(field)}
                                    required={isRequired(field)}
                                    validState={getValidationState(field)}
                                    {...field}
                                />
                            )}
                        />
                    </div>
                    <div className="form-control m-input">
                        <Field
                            name="thirdPartyLiability.phoneNumber"
                            render={({ field }) => (
                                <PhoneInputField
                                    {...field}
                                    title={"Phone Number"}
                                    id={field.name}
                                    value={field.value}
                                    errorMessage={getErrors(field)}
                                    required={isRequired(field)}
                                    validState={getValidationState(field)}
                                    changeEvent={e => {
                                        setFieldValue(field.name, e);
                                    }}
                                />
                            )}
                        />
                    </div>
                    <div className="form-control m-input">
                        <Field
                            name="thirdPartyLiability.medPayCoverage"
                            render={({ field }) => (
                                <InputField
                                    id={field.name}
                                    title={"Med Pay Coverage"}
                                    placeholder={"Med Pay Coverage"}
                                    errorMessage={getErrors(field)}
                                    required={isRequired(field)}
                                    validState={getValidationState(field)}
                                    {...field}
                                />
                            )}
                        />
                    </div>
                    <div className="form-control m-input">
                        <Field
                            name="thirdPartyLiability.liabilityLimits"
                            render={({ field }) => (
                                <InputField
                                    type="tel"
                                    id={field.name}
                                    title={"Liability Limits"}
                                    placeholder={"Liability Limits"}
                                    errorMessage={getErrors(field)}
                                    required={isRequired(field)}
                                    validState={getValidationState(field)}
                                    {...field}
                                />
                            )}
                        />
                    </div>
                </div>
            )}
            {values.thirdPartyLiability.typeOfAccident === "At a place of business" && (
                <div className="form-section">
                    <div className="form-control l-input">
                        <Field
                            name="thirdPartyLiability.businessName"
                            render={({ field }) => (
                                <InputField
                                    id={field.name}
                                    title={"Business Name"}
                                    placeholder={"Business Name"}
                                    errorMessage={getErrors(field)}
                                    required={isRequired(field)}
                                    validState={getValidationState(field)}
                                    {...field}
                                />
                            )}
                        />
                    </div>
                    <div className="form-control l-input">
                        <Field
                            name="thirdPartyLiability.contactName"
                            render={({ field }) => (
                                <InputField
                                    id={field.name}
                                    title={"Contact Name"}
                                    placeholder={"Contact Name"}
                                    errorMessage={getErrors(field)}
                                    required={isRequired(field)}
                                    validState={getValidationState(field)}
                                    {...field}
                                />
                            )}
                        />
                    </div>
                    <div className="form-control m-input">
                        <Field
                            name="thirdPartyLiability.policyNumber"
                            render={({ field }) => (
                                <InputField
                                    id={field.name}
                                    title={"Policy number"}
                                    placeholder={"Policy number"}
                                    errorMessage={getErrors(field)}
                                    required={isRequired(field)}
                                    validState={getValidationState(field)}
                                    {...field}
                                />
                            )}
                        />
                    </div>
                    <div className="form-control m-input">
                        <Field
                            name="thirdPartyLiability.contactPhoneNumber"
                            render={({ field }) => (
                                <PhoneInputField
                                    {...field}
                                    title={"Phone Number"}
                                    id={field.name}
                                    value={field.value}
                                    errorMessage={getErrors(field)}
                                    required={isRequired(field)}
                                    validState={getValidationState(field)}
                                    changeEvent={e => {
                                        setFieldValue(field.name, e);
                                    }}
                                />
                            )}
                        />
                    </div>
                </div>
            )}
            {values.thirdPartyLiability.typeOfAccident === "Victim of violent crime" && (
                <div className="form-section">
                    <div className="form-control auto-input">
                        <YesNoButtons
                            name={"thirdPartyLiability.hasChargesBeenFiledForViolentCrime"}
                            title={`Has ${thePatient} filed charges?`}
                            getErrors={getErrors}
                            isRequired={isRequired}
                            getValidationState={getValidationState}
                            {...formikProps}
                        />
                    </div>
                </div>
            )}
            {values.thirdPartyLiability.typeOfAccident === "Other" && <></>}
            {values.thirdPartyLiability.typeOfAccident !== "" && (
                <div className="form-section">
                    <div className="form-control">
                        <Field
                            name="thirdPartyLiability.additionalNotes"
                            className="form-control"
                            render={({ field }) => (
                                <TextArea
                                    style={{ maxWidth: "600px", height: "100px" }}
                                    id={field.name}
                                    title="Additional Notes"
                                    placeholder="Enter note body..."
                                    errorMessage={getErrors(field)}
                                    required={isRequired(field)}
                                    validState={getValidationState(field)}
                                    {...field}
                                />
                            )}
                        />
                    </div>
                </div>
            )}
        </>
    );
};
